import React, { Fragment } from 'react';
import { Alert } from 'reactstrap';
import qs from 'query-string';
import plural from 'pluralize';
import { withRouter } from 'react-router-dom';

const URLParamBanner = ({ location, name, addWord = 'added' }) => {
  const parsed = qs.parse(location.search);
  let nameToDisplay = name || parsed.name;
  return (
    <Fragment>
      {parsed.new && (
        <div className="content mb3">
          <Alert color="success">
            Successfully {addWord} {nameToDisplay && `new ${nameToDisplay}`} <em>{parsed.new}</em>
          </Alert>
        </div>
      )}
      {parsed.updated && (
        <div className="content mb3 ">
          <Alert color="success">Successfully updated {nameToDisplay && nameToDisplay}</Alert>
        </div>
      )}
      {parsed.archived && (
        <div className="content mb3">
          <Alert color="success">
            Successfully archived {nameToDisplay && nameToDisplay} <em>{parsed.archived}</em>
          </Alert>
        </div>
      )}
      {parsed.new_multiple && (
        <div className="content mb3">
          <Alert color="success">
            Successfully
            {addWord} {parsed.new_multiple} new {plural(nameToDisplay, parsed.new_multiple)}
          </Alert>
        </div>
      )}
    </Fragment>
  );
};

export default withRouter(URLParamBanner);



// WEBPACK FOOTER //
// ./src/components/urlParamBanner/urlParamBanner.jsx